export default "__VITE_ASSET__C$ml9AV4__"